import type { ReactNode } from 'react';
import { Suspense } from 'react';

import useImpactIdentify from '@picsart/rc/useImpactIdentify';

import useUserData from 'hooks/useUserData';

const Main = ({ children }: { children: ReactNode }) => {
  useUserData();
  useImpactIdentify();
  return <Suspense fallback={null}>{children}</Suspense>;
};

export default Main;
